import type { BrandConfig } from "../index";

/**
 * DISCANTO (discanto.pl) — sklep modowy na kodzie lavmaga, osobna instancja
 * PrestaShop z WŁASNĄ bazą. Wcześniej przygotowywany pod kryptonimem `thelineup`
 * (nic z tamtej gałęzi nie zostało wdrożone).
 *
 * Sprzedawca: od 16.10.2026 TEN SAM PODMIOT co lavmag — LAV-MAG Patryk Twardy
 * (jednoosobowa działalność gospodarcza, bez KRS), wcześniej Supply Pack
 * Fulfillment sp. z o.o. Dlatego adres siedziby (Metalurgiczna 11) i NIP są tu
 * takie same jak lavmaga — to poprawne dane sprzedawcy discanto, nie przeciek.
 *
 * DISCANTO pozostaje jednak OSOBNĄ MARKĄ. Poza nazwą prawną, adresem siedziby
 * i NIP-em żadna dana kontaktowa ani treść lavmaga nie może tu trafić — telefon,
 * e-mail, nazwa „LAVMAG", konto Wygodne Zwroty, profile społecznościowe, opinie
 * i linki kategorii są albo własne, albo puste. Dane kontaktowe z listy
 * wdrożeniowej klienta (discanto_lista.csv, 01.10.2026), dane sprzedawcy
 * z decyzji z 16.10.2026.
 *
 * Układ = lavmag, wygląd z księgi znaku DISCANTO (02.10.2026): paleta Obsidian
 * Noir / Fog Silver + kolory dodatkowe, Funnel Sans w treści i Google Sans Flex
 * w nagłówkach. Wszystko ZDUBLOWANE, nie współdzielone z lavmagiem:
 *   - ten plik presetu,
 *   - PEŁNY blok tokenów [data-brand="discanto"] w app/assets/css/themes.css
 *     (nic dziedziczone z :root — inaczej zmiana palety lavmaga przemalowałaby
 *     discanto bez śladu w diffie),
 *   - katalog assetów public/brands/discanto/ (także fonty nagłówków).
 *
 * Logo (logo.svg, logo-inverted.svg) to pliki od grafika 1:1. Ścieżki logo.png
 * i pwa-icons/icon-192.png czyta też backend (maile, ikony web push), więc nie
 * wolno ich przenosić. logo.png ma płótno 300×56 = 2× pudełka 150×28, w którym
 * wyświetlają je szablony maili — inaczej logo 8,8:1 zostałoby ściśnięte.
 *
 * Favicon, apple-touch-icon i ikony PWA są TYMCZASOWE: litera „D" wycięta z
 * logotypu (#161616 na #F4F4F4), bo osobnego sygnetu nie dostaliśmy, a księga
 * każe w małych zastosowaniach używać samego sygnetu. Oficjalny sygnet podmienia
 * się 1:1 pod tymi samymi nazwami.
 *
 * Czego tu ŚWIADOMIE NIE MA (brak sekcji = funkcja wyłączona):
 *   - `standingPromo` — brak akcji kodów progowych (decyzja klienta),
 *   - `reviews` — brak konta opinii na start; konto eKomi lavmaga należy do lavmaga,
 *   - `pwa.screenshots` — screenshoty lavmaga pokazują jego sklep i logo,
 *   - `variants` — układ domyślny, czyli ten sam co lavmag.
 */
export const discantoBrand: BrandConfig = {
  id: "discanto",
  name: "DISCANTO",
  currency: "PLN",
  // Jak lavmag (decyzja klienta). MUSI zgadzać się z PS_SHIPPING_FREE_PRICE w bazie
  // discanto — osobna instancja, więc wartość ustawia się tam niezależnie.
  freeShippingThreshold: 150,
  // UWAGA: to NIE jest fallback runtime. Pole czyta tylko nuxt.config.ts przy
  // BUILDZIE (`site.url`), a obraz buduje się z marką domyślną. Canonical, og:image
  // i powroty płatności biorą runtimeConfig.public.siteUrl, którego wartością
  // domyślną jest lavmag.eu (nuxt.config.ts) — dlatego inventory discanto MUSI
  // ustawiać nuxt_public_site_url (QA: discanto-front-testing.easyitem.pl,
  // prod: discanto.pl; oba ustawione).
  siteUrl: "https://discanto.pl",
  // Pole nieczytane przez żaden komponent ani serwer — zostaje puste zamiast
  // wskazywać host obrazów lavmaga (jak u proles).
  cdnHost: "",
  // Discanto NIE ma konta „Wygodne Zwroty". Konto lavmaga, mimo wspólnego
  // sprzedawcy, jest oznakowane marką lavmag — klient discanto trafiłby do cudzej
  // marki. Puste wartości są bezpieczne: /zwroty i szuflada zwrotów w koszyku
  // pokazują wtedy adres zwrotu i e-mail, a /account/returns odsyła na /zwroty
  // zamiast na pusty adres. Własne konto WZ = wpisanie tych dwóch pól (albo, bez deployu,
  // NUXT_PUBLIC_RETURNS_URL / NUXT_PUBLIC_RETURNS_WITHDRAWAL_URL w inventory).
  returnsUrl: "",
  returnsWithdrawalUrl: "",
  // Zwroty idą do magazynu, nie do siedziby (lista wdrożeniowa klienta).
  // Odbiorca = sprzedawca (LAV-MAG Patryk Twardy od 16.10.2026), magazyn bez zmian.
  returnsAddress: {
    name: "LAV-MAG Patryk Twardy",
    street: "Witosa 38",
    postalCode: "20-315",
    city: "Lublin",
  },
  // Stopka jest ciemna (#161616) — księga: na ciemnym tle logo w wersji jasnej.
  logo: { src: "/brands/discanto/logo.svg", srcInverted: "/brands/discanto/logo-inverted.svg" },
  // Font nagłówków stoi w hero na pierwszym ekranie — preload jak Funnel Sans
  // w nuxt.config.ts. latin-ext (polskie znaki) dociąga się sam przy użyciu.
  fontPreload: ["/brands/discanto/fonts/google-sans-flex-latin.woff2"],
  favicon: {
    svg: "/brands/discanto/favicon.svg",
    ico: "/brands/discanto/favicon.ico",
    appleTouchIcon: "/brands/discanto/apple-touch-icon-180.png",
  },
  // Puste stany (ulubione, zamówienia, brak wyników) prowadzą do listingu, który
  // nie zależy od ID kategorii — katalog discanto ma własną numerację.
  shopEntryHref: "/nowosci",
  // Modal instalacji PWA i /offline — własna ikona, nie „L" lavmaga z /pwa-icons/.
  appIcon: "/brands/discanto/pwa-icons/icon-192.png",
  // Baner stron kategorii — zdjęcie hero discanto zamiast mapy zdjęć lavmaga.
  categoryBanner: "/brands/discanto/home/hero-kobieta.jpg",
  footer: {
    // Siedziba sprzedawcy — ta sama co lavmaga (wspólny podmiot od 16.10.2026).
    address: "Metalurgiczna 11",
    postalCode: "20-234",
    city: "Lublin",
    country: "Polska",
    email: "info@discanto.pl",
    // Klient: telefon „nie będzie dostępny dla klientów". Pusty = stopka i strona
    // kontaktu chowają wiersz telefonu (żadnego `tel:` ani etykiety bez numeru).
    phone: "",
    copyrightName: "DISCANTO",
    createdBy: "contelizer.pl",
    // Pełna firma przedsiębiorcy (strona kontaktu, klauzule RODO, adresat zwrotów).
    // Lavmag ma w `legalName` samo „LAVMAG" (zgłoszenie klienta 2026-09-29); tu
    // pełna nazwa z myślnikiem — nazwa marki „LAVMAG" nadal nie pojawia się na
    // discanto (pilnują tego testy przecieków).
    legalName: "LAV-MAG Patryk Twardy",
    legalSeat: "Lublinie",
    taxId: "7132957431",
    // REGON nieznany — wiersz się nie renderuje. KRS brak: JDG nie ma wpisu
    // w KRS, więc pola `krs` celowo nie ma (wiersz „KRS:" się nie renderuje).
    // Godzin obsługi klient nie podał — pusty łańcuch chowa blok na stronie kontaktu.
    serviceHours: "",
    // Bez linków kategorii lavmaga: wskazują ID z JEGO bazy (/16190-odziez-damska…),
    // które w bazie discanto dałyby 404 w stopce każdej podstrony. Do rozbudowy,
    // gdy powstanie drzewo kategorii discanto.
    links: [
      { label: "Nowości", href: "/nowosci" },
      { label: "Marki", href: "/marki" },
      { label: "Wszystkie produkty", href: "/search" },
    ],
  },
  // Profile z listy klienta, bez parametrów śledzących z udostępnionych linków.
  // TikToka jeszcze nie ma (dojdzie po starcie) — brak wpisu = brak ikony.
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61594873730940",
    instagram: "https://www.instagram.com/discanto.80off",
  },
  seo: {
    titleTemplate: "%s · DISCANTO",
    // Claim z księgi znaku. Bez haseł i liczb lavmaga („Moda Less Waste", „do -78%").
    defaultTitle: "DISCANTO – Markowa moda w lepszej cenie",
    defaultDescription: "Markowa moda w lepszej cenie — odzież i akcesoria znanych marek w sklepie internetowym DISCANTO.",
    ogImage: "/brands/discanto/og-image.png",
    // Obsidian Noir; manifest bierze go też jako background_color.
    themeColor: "#161616",
  },
  // PWA włącza inventory (NUXT_PUBLIC_PWA_ENABLED + NUXT_PUBLIC_PWA_ROLLOUT_PERCENT);
  // bez tego pwa-register.client.ts nie rejestruje service workera. Własny push
  // wymaga osobnych kluczy VAPID discanto. Manifest (site.webmanifest), ikony
  // poniżej i strona /offline (runtime, pobierana przez SW — app/sw/offlinePage.ts)
  // są już własne.
  pwa: {
    name: "DISCANTO – Markowa moda w lepszej cenie",
    shortName: "DISCANTO",
    description: "Markowa moda w lepszej cenie — odzież i akcesoria znanych marek",
    // Własny katalog ikon. Lavmag trzyma swoje we WSPÓLNYM /pwa-icons/*, więc
    // wskazanie tam oznaczałoby, że podmiana ikony discanto zmienia też lavmaga.
    icons: [
      { src: "/brands/discanto/pwa-icons/icon-192.png", sizes: "192x192", type: "image/png", purpose: "any" },
      { src: "/brands/discanto/pwa-icons/icon-512.png", sizes: "512x512", type: "image/png", purpose: "any" },
      { src: "/brands/discanto/pwa-icons/icon-maskable-512.png", sizes: "512x512", type: "image/png", purpose: "maskable" },
    ],
  },
  // Przelewy24 (konto w trakcie rejestracji) — ta sama para co lavmag. Lista jest
  // PREZENTACYJNA; autorytatywne metody zwraca backend w checkoucie.
  paymentLogos: [
    { src: "/images/brands/blik.svg", alt: "BLIK", width: 42, height: 20 },
    { src: "/images/brands/przelewy24.svg", alt: "Przelewy24", width: 20, height: 20 },
  ],
};
